const pricingPeriods = [
    {
        period: "G\xFCltig von 01. Mai 2027 \u2013 31. Oktober 2027",
        rows: [
            { label: "Einzelzimmer", villa: "\u20AC 140,00", aadya: "\u20AC 130,00" },
            { label: "Doppelzimmer", villa: "\u20AC 130,00", aadya: "\u20AC 120,00" },
            { label: "Aufenthalt ohne Kur / \xDC / VP", villa: "EZ \u20AC 90,00 / DZ \u20AC 75,00", aadya: "EZ \u20AC 80,00 / DZ \u20AC 65,00" }
        ]
    },
    {
        period: "G\xFCltig von 01. November 2025 \u2013 30. April 2026",
        rows: [
            { label: "Einzelzimmer", villa: "\u20AC 190,00", aadya: "\u20AC 175,00" },
            { label: "Doppelzimmer", villa: "\u20AC 170,00", aadya: "\u20AC 155,00" },
            { label: "Aufenthalt ohne Kur / \xDC / VP", villa: "EZ \u20AC 90,00 / DZ \u20AC 75,00", aadya: "EZ \u20AC 75,00 / DZ \u20AC 60,00" }
        ]
    },
    {
        period: "G\xFCltig von 01. Mai 2026 \u2013 31. Oktober 2026",
        rows: [
            { label: "Einzelzimmer", villa: "\u20AC 135,00", aadya: "\u20AC 120,00" },
            { label: "Doppelzimmer", villa: "\u20AC 125,00", aadya: "\u20AC 110,00" },
            { label: "Aufenthalt ohne Kur / \xDC / VP", villa: "EZ \u20AC 85,00 / DZ \u20AC 70,00", aadya: "EZ \u20AC 70,00 / DZ \u20AC 55,00" }
        ]
    },
    {
        period: "G\xFCltig von 01. November 2026 \u2013 30. April 2027",
        rows: [
            { label: "Einzelzimmer", villa: "\u20AC 195,00", aadya: "\u20AC 185,00" },
            { label: "Doppelzimmer", villa: "\u20AC 175,00", aadya: "\u20AC 165,00" },
            { label: "Aufenthalt ohne Kur / \xDC / VP", villa: "EZ \u20AC 95,00 / DZ \u20AC 80,00", aadya: "EZ \u20AC 85,00 / DZ \u20AC 70,00" }
        ]
    }
];
const extraNotes = [
    "Flughafen-Transfer \u20AC 85,00 pro Fahrt (bis 02 Personen)",
    "Zuschlag \u20AC 10,00 pro Tag/Nacht f\xFCr Zimmer mit Klimaanlage",
    "Zuschlag \u20AC 10,00 pro Tag/Nacht f\xFCr Wunschzimmer, die fest gebucht werden",
    "Bei Anreise am Vormittag wird der Tag als Behandlungstag berechnet",
    "Bei Anreise am Nachmittag gilt der Preis f\xFCr den Aufenthalt ohne Kur",
    "Bei Abreise ab dem Nachmittag wird der Tag als Behandlungstag berechnet",
    "Spezialtransfers und Rundreisen mit Reisebegleitung organisieren wir ebenso gerne auf Anfrage."
];
const PricingTable = ({ rows }) => <div className="overflow-hidden rounded-2xl border border-slate-200 shadow-[0_18px_40px_rgba(15,23,42,0.04)]">
    <div className="overflow-x-auto">
        <table className="min-w-full divide-y divide-slate-200 bg-white text-left text-sm">
            <thead className="bg-[#f7f3eb] text-black">
                <tr>
                    <th className="px-4 py-4 font-semibold text-black">Leistungen</th>
                    <th className="px-4 py-4 font-semibold text-black">Hiru Villa / Hiru Om / Hiru Mudra / Hiru Beach</th>
                    <th className="px-4 py-4 font-semibold text-black">Hiru Aadya</th>
                </tr>
            </thead>
            <tbody className="divide-y divide-slate-200">
                {rows.map((row) => <tr key={row.label} className="align-top transition-colors hover:bg-[#faf7f3]">
                    <td className="px-4 py-4 font-medium text-black">{row.label}</td>
                    <td className="px-4 py-4 whitespace-pre-line text-black">{row.villa}</td>
                    <td className="px-4 py-4 whitespace-pre-line text-black">{row.aadya}</td>
                </tr>)}
            </tbody>
        </table>
    </div>
</div>;
export default function PricingPage() {
    return <main className="bg-[#f6f1e8] text-slate-800">
        <section className="relative isolate overflow-hidden border-t border-amber-100 bg-[#07130d] py-20 sm:py-24 lg:py-40 xl:py-56">
            <img
                src="/images/Hiru/Hiru Villa's/Close Up/AH2I0610-2-copy.webp"
                alt="Hintergrundbild für die Ayurveda-Preise in Sri Lanka"
                className="object-cover object-center" style={{ position: "absolute", inset: 0, width: "100%", height: "100%" }} loading="eager" fetchPriority="high" />

            <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/35 to-black/70" />

            <div className="relative z-10 mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
                <div className="mx-auto flex min-h-[360px] max-w-5xl items-center justify-center sm:min-h-[420px] lg:min-h-[520px]">
                    <div className="w-full max-w-4xl p-4 text-center text-white sm:p-6 lg:px-10 lg:py-8">
                        <div className="absolute left-8 top-10 hidden lg:block">
                            <svg width="289" height="245" viewBox="0 0 289 245" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M289 1H1V244.5" stroke="white" strokeWidth="2" />
                            </svg>
                        </div>

                        <div className="absolute -bottom-12 right-8 hidden lg:block">
                            <svg width="289" height="244" viewBox="0 0 289 244" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M0 243.5H288V0" stroke="white" strokeWidth="2" />
                            </svg>
                        </div>

                        <div className="mx-auto mb-6 h-1.5 w-20 rounded-full bg-gradient-to-r from-[#F28600] to-[#ffb347]" />

                        <h1 className="font-serif text-4xl font-light leading-tight tracking-tight sm:text-5xl lg:text-6xl">
                            Preise & Behandlungszeiten
                        </h1>

                        <p className="mx-auto mt-6 max-w-3xl text-lg leading-relaxed text-white/88 sm:text-xl lg:text-2xl">
                            Transparente Preise für Ayurveda-Aufenthalte, Zimmer, Transfers und Zusatzleistungen bei Hiru Ayurveda Resorts.
                        </p>
                    </div>
                </div>
            </div>
        </section>

        <section className="mx-auto max-w-6xl px-4 py-14 sm:px-6 lg:px-8">
            <div className="rounded-[30px] bg-white p-6 shadow-[0_25px_70px_rgba(24,42,33,0.08)] sm:p-8 lg:p-10">
                <div className="mb-8 rounded-2xl border border-amber-200 bg-gradient-to-r from-[#fff9ef] to-[#f8f0e1] p-5 shadow-sm">
                    <p className="text-[11px] font-semibold uppercase tracking-[0.25em] text-amber-700">Wichtiger Hinweis</p>
                    <p className="mt-3 text-sm text-black sm:text-[15px]">
                        Die angegebenen Preise enthalten die srilankische Mehrwertsteuer (VAT). Flugtickets sind nicht inbegriffen.
                    </p>
                </div>

                {pricingPeriods.map((period) => <div key={period.period} className="mt-8">
                    <div className="rounded-2xl border border-amber-200 bg-gradient-to-r from-[#fff9ef] to-[#f8f0e1] p-5 shadow-sm">
                        <h2 className="font-serif text-2xl text-[#1f4d3c] sm:text-3xl">{period.period}</h2>
                        <p className="mt-2 text-sm font-medium text-black sm:text-[15px]">Preise pro Behandlungstag</p>
                    </div>

                    <div className="mt-6">
                        <PricingTable rows={period.rows} />
                    </div>
                </div>)}

                <div className="mt-10 rounded-[24px] bg-[#1d2f2a] p-6 text-white shadow-[0_25px_60px_rgba(22,35,25,0.15)]">
                    <h3 className="font-serif text-2xl text-[#f3e3b6] sm:text-3xl">Zusätzliche Bedingungen</h3>
                    <ul className="mt-5 space-y-3 text-sm leading-7 text-white sm:text-[15px]">
                        {extraNotes.map((item) => <li key={item}>• {item}</li>)}
                    </ul>
                </div>
            </div>
        </section>
    </main>;
}
